<template>
  <div>
    <el-row class="detail-header-wrap">
      <BaseHeader
          :title="pageTitle"
          icon="stock"
          class="stockAlert-header" />
      <BaseBackButton
          :is-show="showBackButton"
          return-destination="/stockAlert" />
    </el-row>
    <el-row>
      <el-col :span="12">
        <div class="edit-table-list">
          <div class="table-vertical">
            <div class="edit-button-wrap">
              <el-dropdown
                  v-show="showActionButtonComponent"
                  placement="bottom-start"
                  @command="actionCommand">
                <el-button size="small">
                  アクション
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu
                    slot="dropdown"
                    class="header-action-menu">
                  <el-dropdown-item
                      v-if="$isFunctionShown(define.PermissionKeys.Stock.Alert.Detail.EDIT)"
                      :disabled="$isFunctionDisabled(define.PermissionKeys.Stock.Alert.Detail.EDIT)"
                      :command="define.STOCK_ALERT_MODE.EDIT">
                    編集
                  </el-dropdown-item>
                  <el-dropdown-item
                      v-if="$isFunctionShown(define.PermissionKeys.Stock.Alert.Detail.NEW)"
                      :disabled="$isFunctionDisabled(define.PermissionKeys.Stock.Alert.Detail.NEW)"
                      :command="define.STOCK_ALERT_MODE.NEW">
                    新規
                  </el-dropdown-item>
                  <el-dropdown-item
                      v-if="$isFunctionShown(define.PermissionKeys.Stock.Alert.Detail.DELETE)"
                      :disabled="$isFunctionDisabled(define.PermissionKeys.Stock.Alert.Detail.DELETE)"
                      :command="define.STOCK_ALERT_MODE.DELETE">
                    削除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <BaseButton v-show="showCancelButton"
                  @click="cancel()">
                キャンセル
              </BaseButton>
              <BaseButton v-show="showSaveButton"
                  :disabled="disableSaveButton"
                  @click="save()">
                保存
              </BaseButton>
            </div>
            <BaseTableDetail
                slot="list"
                :border="true"
                :table-set-list="stockAlertInfo"
                :display-item="detailData"
                :editable="editable" />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<style scoped>
.table-vertical ::v-deep .multipleLines .is-error-msg {
  white-space: pre-line;
  margin-top: -12px;
  margin-bottom: -6px;
}
.table-vertical ::v-deep .productIds button {
  padding: 3px 3px;
  border: none;
  background-color: white;
  font-size: 12pt;
}
.table-vertical ::v-deep .productIds .delBtn > button{
  color: rgb(226, 41, 8)
}
.table-vertical ::v-deep .productIds .addBtn > button{
  color: rgb(46, 122, 36)
}
.table-vertical ::v-deep .productIds button:focus,
.table-vertical ::v-deep .productIds button:hover {
  background-color: white;
}
.table-vertical ::v-deep .productIds .flex > :first-child {
  flex-grow: 1;
  max-width: 200px;
}
.table-vertical ::v-deep .productIds.th:after {
  content: " *";
  color: #ff5a5a;
  font-size: 85%;
}
.table-vertical ::v-deep .alertClear span {
  color: rgb(226, 41, 8)
}
</style>
<script>
import _ from 'lodash'
import { mapState, mapMutations, mapGetters } from 'vuex'
import store from '@/store/index'

import * as define from '@/define'
import * as stockQuery from '@/queries/stock'
import common from '@/utils/common'
import compare from '@/utils/compareUtils'
import * as config from '@/config'
import message from '@/utils/message'

import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import x from '@/components/mixins/mixin'
import confirmDiscardOnLeave from '@/components/mixins/confirmDiscardOnLeave'

import BaseButton from '@/components/atoms/BaseButton'
import BaseHeader from '@/components/molecules/BaseHeader'
import BaseBackButton from '@/components/molecules/BaseBackButton'
import BaseTableDetail from '@/components/molecules/BaseTableDetail'
import detailUtil from '@/components/mixins/detailUtil'

const EDITABLE = Object.freeze({
  [define.STOCK_ALERT_MODE.NORMAL]: Object.freeze({}),
  [define.STOCK_ALERT_MODE.EDIT]: Object.freeze({ status: true, no: true, productId: true, stockType: true, alertValue: true, alertType: true, note: true }),
  [define.STOCK_ALERT_MODE.NEW]: Object.freeze({ site: true, status: true, no: true, productId: true, stockType: true, alertValue: true, alertType: true, note: true })
})

const returnDestination = '/stockAlert'
const returnDestinationTitle = 'CCS - EC在庫アラート設定一覧'

const alertValidationRules = (v) => {
  // 商品IDのサイズ形式チェック
  v.$validator.extend('pIdSizeCheck', {
    getMessage: () => 'カンマで区切って入力した商品IDの文字数が1000を超えています',
    validate: (data) => {
      if (v.detailData.productId.length > 1000) {
        return false
      }
      return true
    }
  })
  // 商品IDの重複チェック
  v.$validator.extend('pIdDuplicateCheck', {
    getMessage: () => '同じ商品IDが存在します',
    validate: (data) => {
      if (v.detailData.productId.split(',').filter((val, key) => { return val === data }).length > 1) {
        return false
      }

      return true
    }
  })
  // 設定(値)の形式チェック
  v.$validator.extend('numCheck', {
    getMessage: () => '設定(値)に0以上の数値を入力してください',
    validate: (data) => {
      if (Number(data) === 0) {
        return false
      }
      return true
    }
  })
}

export default {
  name: 'StockAlertDetail',
  components: {
    BaseButton,
    BaseHeader,
    BaseBackButton,
    BaseTableDetail
  },
  mixins: [ x, confirmDiscardOnLeave, detailUtil ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      detailData: {},
      originData: {},
      noList: [],
      originNoList: [],
      isChanged: false,
      reservedTransition: false,
      canMoveData: false
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      listIndex: (state) => state.StockAlert.listIndex,
      mode: (state) => state.StockAlert.mode,
      sites: (state) => state.sites
    }),
    ...mapGetters({
      getServiceSiteConfig: 'getServiceSiteConfig',
      searchConditions: 'searchConditions'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    storePath () {
      return 'StockAlert'
    },
    sortedList () {
      return this.$store.getters['sortedList'](this.storePath, this.sortCondition('stockAlertList'))
    },
    pageTitle () {
      return this.mode === define.STOCK_ALERT_MODE.NEW
        ? 'EC在庫アラート設定登録'
        : 'EC在庫アラート設定詳細'
    },
    showDetailMoveDataComponent () {
      return this.mode !== define.STOCK_ALERT_MODE.NEW
    },
    showActionButtonComponent () {
      return (this.showActionButton &&
             (this.$isFunctionShown(define.PermissionKeys.Stock.Alert.Detail.EDIT) ||
              this.$isFunctionShown(define.PermissionKeys.Stock.Alert.Detail.NEW) ||
              this.$isFunctionShown(define.PermissionKeys.Stock.Alert.Detail.DELETE)))
    },
    stockAlertInfo () {
      return [
        {
          label: 'サイト',
          properties: [
            {
              path: 'ecStockAlert.site.code', type: 'String', codeName: 'sites', selectCode: 'sites',
              validateRule: 'required', validateAs: 'サイト', editableId: 'site', elementType: ELEMENT_TYPE.RADIO_BUTTON,
              horizontal: false, class: 'multipleLines', change: (event) => { this.onSiteClick(event) }
            }
          ]
        },
        {
          label: '有効 / 無効',
          properties: [
            {
              path: 'isEnabled', type: 'String',
              selectCode: () => [
                { code: 1, name: '有効' },
                { code: 0, name: '無効' }
              ],
              validateRule: 'required', editableId: 'status', elementType: ELEMENT_TYPE.RADIO_BUTTON,
              horizontal: false
            }
          ]
        },
        {
          label: '適用順',
          properties: [
            {
              type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX, path: 'no',
              editableId: 'no', filterable: true, validateRule: 'required', validateAs: '適用順',
              selectCode: () => _.map(this.noList, (val) => ({ code: val.code, name: val.name })),
              codeName: (code) => _.chain(this.noList)
                .find(val => val.code === code)
                .get('name')
                .value()
            }
          ]
        },
        {
          id: 'productIds',
          label: '対象商品',
          properties: [
            {
              type: 'String', elementType: ELEMENT_TYPE.CELL, path: 'productId', editableId: 'productId',
              properties: this.validIpsObjData,
              class: 'productIds'
            }
          ]
        },
        {
          label: '対象在庫種別',
          properties: [
            {
              type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX, path: 'stockType',
              validateRule: 'required', validateAs: '対象在庫種別',
              editableId: 'stockType', filterable: true, selectCode: this.stockTypeList,
              codeName: (code) => (this.stockTypeList().find(element => code === element.code) || {}).name
            }
          ]
        },
        {
          label: '設定',
          properties: [
            {
              path: 'alertValue', type: 'Number', elementType: ELEMENT_TYPE.INPUT_NUMBER, editableId: 'alertValue',
              validateRule: 'required|numeric|max:12|numCheck', validateAs: '設定(値)'
            },
            {
              type: 'String', elementType: ELEMENT_TYPE.SELECT_BOX, path: 'alertType',
              validateRule: 'required', validateAs: '設定',
              editableId: 'alertType', filterable: true, selectCode: this.alertTypeList,
              codeName: (code) => (this.alertTypeList().find(element => code === element.code) || {}).name
            }
          ],
          horizontal: true
        },
        {
          label: '備考',
          properties: [
            {
              path: 'note', type: 'String', elementType: ELEMENT_TYPE.INPUT, editableId: 'note',
              validateRule: 'max:50', validateAs: '備考'
            }
          ]
        },
        {
          id: 'alertClear',
          label: 'アラート状況のクリア',
          properties: [
            { type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: 'アラート状態のSKUが存在します。', class: 'alertClear' },
            {
              path: 'resetAlerted', type: 'String', editableId: 'status',
              elementType: ELEMENT_TYPE.CHECK_BOX, single: true, label: 'アラート状況をクリアする'
            }
          ],
          isShow: () => (this.mode === define.STOCK_ALERT_MODE.EDIT && this.detailData.showClearAlerted),
          horizontal: false
        }
      ]
    },
    showBackButton () {
      return this.mode === define.STOCK_ALERT_MODE.NORMAL && !this.$isFunctionDisabled(define.PermissionKeys.Stock.Alert.LIST)
    },
    showActionButton () {
      return this.mode === define.STOCK_ALERT_MODE.NORMAL
    },
    showSaveButton () {
      return this.mode !== define.STOCK_ALERT_MODE.NORMAL
    },
    disableSaveButton () {
      return !this.isChanged
    },
    showCancelButton () {
      return this.mode !== define.STOCK_ALERT_MODE.NORMAL
    },
    editable () {
      return EDITABLE[this.mode]
    },
    editableValidIds () {
      return this.mode !== define.STOCK_ALERT_MODE.NORMAL
    },
    /**
     * 商品コンポーネントを作成する
     */
    validIpsObjData () {
      let objData = []
      if (this.detailData == null) {
        return
      }
      if (this.detailData.productId != null) {
        const ids = this.detailData.productId.split(',')
        ids.forEach((productId) => {
          const index = objData.length
          let propertiesData = [{
            id: 'productIdsTxt', type: 'String', elementType: ELEMENT_TYPE.INPUT, path: 'productId',
            validateScope: 'productIds', displayItem: { productId },
            validateRule: `${this.requestProductIds(index)}|pIdDuplicateCheck|pIdSizeCheck`, validateAs: '対象商品',
            change: (event) => { this.onChangeProductIds(event, index) },
            editable: true,
            editableCondition: () => this.editableValidIds
          }]

          // 行削除用ボタン
          if (this.editableValidIds && ids.length > 1) {
            propertiesData.push({
              type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'delBtn',
              icon: 'fas fa-times-circle', click: (event) => { this.onClickidDelBtn(index) }
            })
          }

          // 追加ボタン（新規登録・編集時に使用可能。商品IDの最終行に表示）
          if (this.editableValidIds && ids.length === index + 1) {
            propertiesData.push({
              id: 'addBtn',
              type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'addBtn',
              icon: 'fas fa-plus-circle', size: 'small', click: this.onClickIDAddBtn
            })
          }
          // コメント（１行目だけ）
          if (index === 0 && this.mode !== define.STOCK_ALERT_MODE.NORMAL) {
            propertiesData.push({
              type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT, path: '（最後に*を指定すると前方一致）'
            })
          }

          objData.push({
            // カスタムタイプのセルを指定
            type: 'String', elementType: ELEMENT_TYPE.CELL,
            properties: propertiesData,
            index: index,
            horizontal: true,
            computesRequired: 'required'
          })
        })
      } else {
        // 新規登録場合
        if (this.editableValidIds) {
          objData.push({
            id: 'addBtn',
            type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'addBtn',
            icon: 'fas fa-plus-circle', size: 'small', click: this.onClickIDAddBtn
          })
        }
      }

      return objData
    }
  },
  watch: {
    detailData: {
      handler: function (val, oldVal) {
        this.isChanged = this.$_ConfirmDiscardOnLeave_isChanged()
      },
      deep: true
    },
    mode (val) {
      // 既に遷移予定である場合、制御不要
      if (!this.reservedTransition) {
        const route = this.$route
        if (val === define.STOCK_ALERT_MODE.NORMAL &&
          (route.params && route.params.id === '0')) {
          this.$router.push({ path: returnDestination })
        }
        // ページタイトルの再設定
        document.title = `CCS - ${this.pageTitle}`
      }
    }
  },
  async created () {
    // ページタイトルの設定
    document.title = `CCS - ${this.pageTitle}`
    window.addEventListener('beforeunload', this.onBeforeUnload)
    this.$loadingService.show()
    try {
      // カスタムバリデーションルールを追加
      alertValidationRules(this)

      // 詳細データ取得
      await this.getDetailData()

      // 新規モードの場合
      if (this.mode === define.STOCK_ALERT_MODE.NEW) {
        this.originData = _.cloneDeep(this.detailData)
        this.$_ConfirmDiscardOnLeave_watchStart(this.detailData, '在庫アラート登録を中止しますか？')
      }
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  destroyed () {
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  },
  beforeRouteEnter (to, from, next) {
    // [beforeRouteEnter]ではvueコンポーネントの生成が未完であるため、「this.$store」で呼び出しができない。
    // そのため、storeのあるファイルをImportし、直接参照している。
    if (to.params && to.params.id === '0' && store.state.StockAlert.mode !== define.STOCK_ALERT_MODE.NEW) {
      // 履歴の操作により、入ってきたとき、storeが正しくないので編集
      store.dispatch({ type: 'set', states: { 'StockAlert/mode': define.STOCK_ALERT_MODE.NEW } })
    }

    next()
  },
  async beforeRouteUpdate (to, from, next) {
    // 一覧からの呼び出しの新規作成完了後
    if (from.params && from.params.id === '0') {
      // 戻る等でいきなり新規作成とならないように履歴を修正
      document.title = returnDestinationTitle
      history.replaceState(null, null, returnDestination)
    }
    // ページ送りにより変更した対象アラート情報のデータ取得（ページ送り時のモードは通常モードに制御されているため、初期化不要）
    next()
    await this.getDetailData()
  },
  beforeRouteLeave (to, from, next) {
    // 別ページへ移動する場合、modeを初期化する.
    this.reservedTransition = true
    this.updateMode(define.STOCK_ALERT_MODE.NORMAL)

    next()
  },
  methods: {
    ...mapMutations('StockAlert', {
      updateListItem: 'update'
    }),
    onBeforeUnload (event) {
      if (this.isChanged) {
        // 変更有の場合、再読み込み確認ダイアログを表示する.
        event.returnValue = 'changed'
      }
    },

    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      switch (mode) {
        case define.STOCK_ALERT_MODE.EDIT:
          this.edit()
          break
        case define.STOCK_ALERT_MODE.NEW:
          this.addStockAlert()
          break
        case define.STOCK_ALERT_MODE.DELETE:
          this.deleteStockAlert()
          break
        default: {}
      }
    },
    /**
     * 商品IDの必須制限
     * @param {Number} index 商品項目のIndex
     */
    requestProductIds (index) {
      return this.detailData.productId.split(',').filter(val => val.trim() !== '').length < 1 && index === 0 ? 'required' : ''
    },
    /**
     * EDIT処理
     */
    edit () {
      this.updateMode(define.STOCK_ALERT_MODE.EDIT)
      this.originData = _.cloneDeep(this.detailData)
      this.$_ConfirmDiscardOnLeave_watchStart(this.detailData)
    },
    async addStockAlert () {
      this.updateMode(define.STOCK_ALERT_MODE.NEW)
      await this.getDetailData()
      this.originData = _.cloneDeep(this.detailData)
      this.$_ConfirmDiscardOnLeave_watchStart(this.detailData, 'アラート設定登録を中止しますか？')
    },
    deleteStockAlert () {
      this.$confirm('アラート設定を削除しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          this.$loadingService.show()
          await this.deleteStockAlertApi()
          // 一覧画面データに反映する
          this.updateList()
          this.$notify.success('アラート設定を削除しました。')
          this.updateMode(define.STOCK_ALERT_MODE.NORMAL)
          this.$router.push({ path: returnDestination })
        } catch (error) {
          const data = _.get(error, 'response.data')
          if (data == null) {
            common.addError(error, { msg: message.MSG_502() })
          } else {
            common.addError(error, { msg: message.MSG_533() })
          }
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch(() => {})
    },
    async save () {
      // チェック処理
      if (!await this.$validator.validate()) {
        return
      }

      this.$confirm('保存しますか？', define.MESSAGE_TITLE, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      }).then(async () => {
        try {
          // 商品IDの不要な空行の削除
          this.detailData.productId = this.detailData.productId ? this.detailData.productId.split(/[\s,]+/).filter((val) => val).join(',') : this.detailData.productId
          this.$loadingService.show()
          const res = await this.updateOrInsertEcStockAlertApi()
          this.$_ConfirmDiscardOnLeave_watchEnd()
          this.isChanged = false
          if (this.mode === define.STOCK_ALERT_MODE.NEW) {
            this.reservedTransition = true
            this.updateMode(define.STOCK_ALERT_MODE.NORMAL)
            this.$router.push({ path: `/stockAlert/${res.data.uuid}` })
          } else {
            this.updateMode(define.STOCK_ALERT_MODE.NORMAL)
            await this.getDetailData()
          }
          // 一覧画面データに反映する
          this.updateList()
          this.$notify.success('保存しました。')
        } catch (error) {
          const data = _.get(error, 'response.data')
          if (data == null) {
            common.addError(error, { msg: message.MSG_502() })
          } else {
            if (this.mode === define.STOCK_ALERT_MODE.NEW) {
              common.addError(error, { msg: message.MSG_531() })
            } else {
              common.addError(error, { msg: message.MSG_532() })
            }
          }
          this.$notify.error({ error: error })
          throw error
        } finally {
          this.$loadingService.close()
        }
      }).catch(() => {
        this.$notify.info('キャンセルしました。')
      })
    },
    cancel () {
      const cancelEdit = () => {
        const modeWhenEntered = this.mode
        this.updateMode(define.STOCK_ALERT_MODE.NORMAL)
        // 新規作成から戻ってきたとき、詳細データの再読み込みを行う
        if (modeWhenEntered === define.STOCK_ALERT_MODE.NEW) {
          const route = this.$route
          if (!(route.params && route.params.id === '0')) {
            this.getDetailData()
          }
        }
        this.$_ConfirmDiscardOnLeave_watchEnd()
        this.isChanged = false
      }
      if (!this.isChanged) {
        cancelEdit()
        return
      }
      this.$confirm(
        this.mode === define.STOCK_ALERT_MODE.NEW
          ? 'アラート設定登録を中止しますか？'
          : '変更を破棄しますか？',
        define.MESSAGE_TITLE,
        {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        }
      ).then(() => {
        this.detailData = _.cloneDeep(this.originData)
        this.noList = _.cloneDeep(this.originNoList)
        cancelEdit()
      }).catch(e => e)
    },
    /**
     * アラート設定詳細情報を取得します。
     */
    async getDetailData () {
      try {
        this.$loadingService.show()
        if (this.mode !== define.STOCK_ALERT_MODE.NEW) {
          const query = common.addGraphQlCondition(stockQuery.GRAPH_QL_QUERY_STOCK_ALERT_DETAIL, { uuid: this.$route.params.id })
          const res = await common.postGraphQl(query)
          // 結果が null の場合
          if (res.data.data.ecStockAlertItems.edges.length < 1) {
            this.$notify.error({
              message: 'データを取得できませんでした。'
            })
            return
          }
          // DBから詳細画面の情報を取得
          let item = res.data.data.ecStockAlertItems.edges[0].node

          // アラート状況をクリアする
          item.resetAlerted = 0
          const hasAlerted = item.alerteds.find((element) => Number(element.statusCode) === 1)
          item.showClearAlerted = !!hasAlerted

          this.detailData = item

          // サイトコードの取得
          const siteCode = item.ecStockAlert.site.code
          // サイトコードによる画面適用順リストを取得
          this.noList = await this.getNoList(siteCode)
        } else {
          // 新規の場合、画面各種データの初期化
          let delaultSite = ''
          if (this.sites.length > 0) {
            delaultSite = this.sites[0].code
          }
          this.detailData = {
            no: '',
            productId: '*',
            stockType: '',
            alertType: '',
            alertValue: '',
            isEnabled: 1,
            note: '',
            ecStockAlert: { site: { code: delaultSite } }
          }
          this.noList = await this.getNoList(delaultSite)
        }
        // キャンセルする場合、最初のデータがロールバックできるため、キャッシュする
        this.originData = _.cloneDeep(this.detailData)
        this.originNoList = _.cloneDeep(this.noList)
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    /**
     * 一覧画面のデータを更新する.
     */
    updateList () {
      const queryCondition = this.searchConditions(this.storePath)
      this.updateListItem(queryCondition)
    },
    /**
     * detailData からアラート設定登録APIのリクエストパラメータを作成する.
     */
    buildRequestForInsert () {
      let requestBody = {
        siteCode: this.detailData.ecStockAlert.site.code,
        no: this.detailData.no,
        isEnabled: this.detailData.isEnabled,
        productIds: this.detailData.productId,
        stockType: this.detailData.stockType,
        alertType: this.detailData.alertType,
        alertValue: this.detailData.alertValue,
        note: this.detailData.note
      }
      return requestBody
    },
    /**
     * detailData からアラート設定更新APIのリクエストパラメータを作成する.
     * originDataとの差分のみ戻り値とする.
     */
    buildRequestForUpdate () {
      const diff = compare.diff(this.originData, this.detailData)
      let requestBody = _.pick(diff, ['no', 'isEnabled', 'stockType', 'alertType', 'alertValue', 'note', 'alertType'])
      if (diff.productId) {
        requestBody.productIds = diff.productId || null
      }
      requestBody.resetAlerted = this.detailData.resetAlerted
      return requestBody
    },
    /**
     * アラート設定登録 API またはアラート設定更新 APIを呼び出す
     */
    async updateOrInsertEcStockAlertApi () {
      let url
      let method
      let data
      if (this.mode === define.STOCK_ALERT_MODE.NEW) {
        url = config.EC_STOCK_ALERT
        method = 'post'
        data = this.buildRequestForInsert()
      } else {
        url = config.EC_STOCK_ALERT + '/' + this.detailData.uuid
        method = 'put'
        data = this.buildRequestForUpdate()
      }
      const response = await common.apiAxios(url, { method, data })
      return response
    },
    async deleteStockAlertApi () {
      const url = config.EC_STOCK_ALERT + '/' + this.detailData.uuid
      const method = 'delete'
      const response = await common.apiAxios(url, { method })
      return response
    },
    updateMode (mode) {
      this.$store.commit({
        type: 'set',
        states: {
          'StockAlert/mode': mode
        }
      })
    },
    onClickidDelBtn (index) {
      let ids = this.detailData.productId.split(',')
      ids = ids.filter((val, key) => {
        return key !== index
      })
      this.detailData.productId = ids.length === 0 ? null : ids.join(',')
      // 行番号が変わり、メッセージの出力箇所が不正となるため、再度全行バリデーションチェックを行う。
      this.idsValidationCheck()
    },
    onClickIDAddBtn () {
      if (this.detailData.productId != null) {
        // すでに行があるとき
        this.detailData.productId += ','
      } else {
        // 1行もないとき
        this.detailData.productId = ''
      }
    },
    onChangeProductIds (event, index) {
      // 現在の値更新
      let newIps = []
      const pIdRows = this.stockAlertInfo.find((obj) => { return obj.id === 'productIds' }).properties[0].properties
      Object.keys(pIdRows).forEach((key) => {
        if (key === String(index)) {
          newIps.push(event.replace(/,/g, ''))
        } else {
          if (pIdRows[key].id !== 'addBtn') {
            newIps.push(pIdRows[key].properties.find((obj) => { return obj.id === 'productIdsTxt' }).displayItem.productId.replace(/,/g, ''))
          }
        }
      })
      this.detailData.productId = newIps.join(',')

      // 値変更により重複チェックが解消されたとき、もう一方のエラーを解除する必要があるため、全行バリデーションチェックを行う。
      this.idsValidationCheck()
    },
    idsValidationCheck () {
      setTimeout(() => {
        this.$validator.validate('productIds.*')
      })
    },
    /**
     * サイトコード別画面用Noリストを構築する
     */
    async getNoList (siteCode) {
      const noQuery = common.addGraphQlCondition(stockQuery.GRAPH_QL_QUERY_STOCK_ALERT_LIST, { siteCodes: siteCode })
      const noRes = await common.postGraphQl(noQuery)
      const alertItems = noRes.data.data.ecStockAlertItems.edges

      let noItems = _.map(alertItems, (item) => ({ code: item.node.no, name: item.node.no }))

      if (this.mode === define.STOCK_ALERT_MODE.NEW) {
        let maxNo = 1
        if (noItems.length > 0) {
          const sortNoItems = _.map(noItems, (item) => (item.code))
          maxNo = Math.max.apply(Math, sortNoItems) + 1
        }
        noItems.push({ code: maxNo, name: maxNo })
        this.detailData.no = maxNo
      }
      return noItems
    },
    /**
     * サイトマスタからストックタイプを取得する
     */
    stockTypeList () {
      let stockTypes = []
      let types = this.getServiceSiteConfig(null, 'm_ec_stock_alert', 'stock_type') || []

      Object.keys(types).forEach((key) => {
        stockTypes.push(
          {
            code: Number(key),
            name: _.get(types[key], 'label', null)
          })
      })
      return stockTypes
    },
    /**
     * サイトマスタからアラートタイプを取得する
     */
    alertTypeList () {
      let alertTypes = []
      let types = this.getServiceSiteConfig(null, 'm_ec_stock_alert', 'alert_type') || []
      Object.keys(types).forEach((key) => {
        alertTypes.push(
          {
            code: Number(key),
            name: _.get(types[key], 'label', null)
          })
      })
      return alertTypes
    },
    /**
     * サイト選択した場合、対応のNOリストを再取得する
     */
    async onSiteClick (event) {
      this.noList = await this.getNoList(event)
    }
  }
}
</script>
